import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { UniversalNavigationContextProvider } from '@fff-web/fff-global-nav';
import { FFFErrorBoundary } from '@fff-web/fff-ui-shared';
import { UserProvider } from '@fff-web/fff-utilities';
import App from './Components/App/App';
import store from './store';
import './globals.css';

globalThis.window.FFF = { ...globalThis.window.FFF };
globalThis.window.FFF[process.env.APP_NAME] = {
  version: process.env.APP_VERSION,
  libs: process.env.APP_LIBS,
};

const container = document.querySelector('#root');
const root = createRoot(container!);

root.render(
  <FFFErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <UserProvider>
          <UniversalNavigationContextProvider>
            <App />
          </UniversalNavigationContextProvider>
        </UserProvider>
      </Provider>
    </BrowserRouter>
  </FFFErrorBoundary>,
);
